export const MEDIA_TYPES = {
    TYPE_IMAGE: 'image',
    TYPE_VIDEO: 'video',
    TYPE_EMBED: 'embed',
    TYPE_REEL: 'reel'
};
